// Monthly equivalents for annual software subscriptions; usage add-ons are separate.
export const ANNUAL_SOFTWARE_PRICES = { starter: 129, growth: 199, pro: 299 };

export function annualSoftwarePrice(plan = {}) {
  const display = plan.display_price_amounts?.yearly;
  const stripeAnnual = plan.price_amounts?.yearly?.amount;
  const valid = (value) => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) && Number(value) > 0;
  const monthly = valid(display) ? Number(display)
    : valid(stripeAnnual) ? Number(stripeAnnual) / 12
      : ANNUAL_SOFTWARE_PRICES[String(plan.plan || '').toLowerCase()];
  return monthly === undefined ? null : { monthly, annual: Math.round(monthly * 1200) / 100 };
}

export function formatSoftwareEuro(amount) {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 }).format(amount);
}
